import "../../pages/new/new.scss"

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../api/axios';
import { getAllStudents } from '../../services/studentService';
import { getStudentRequestById } from '../../services/studentRequestService';
export const AddStudentRequest = () => {

    const { studentRequestId } = useParams();
    const [students, setStudents] = useState([]);
    const [studentRequest, setStudentRequest] = useState({
        id:'',
        studentId: '',
        studentName: '',
        request: '',
        active: 'true',
        type: 'Extension',
        
    });

    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [editMode, setEditMode] = useState(false);
    const [viewMode, setViewMode] = useState(false);
    const fetchStudents = async () => {
        try {
            const data = await getAllStudents();
          //  console.log(data);
            setStudents(data.data);
        } catch (err) {

        }
    };
    const findElementByIdWithReduce = (array, id) => {
       // console.log(array);
      //  console.log(id);
        return array.reduce((acc, element) => {
            return element.id === id ? element : acc;
        }, null);
    };
    const fetchStudentRequest = async (id) => {
        try {
            const response = await getStudentRequestById(id);
           // console.log(response.data)
            setStudentRequest(response.data); 
            //console.log(findElementByIdWithReduce(thesis,response.data.thesisId));
            //setSelectedThesisId( findElementByIdWithReduce(thesis,response.data.thesisId));
// Set course details from API response
            //setSelectedExaminerId(response.data.examinerId);
        } catch (error) {
            console.error('Error fetching course:', error);
        }
    };
    
    useEffect(()=>{
        fetchStudents();
    },[]);
    useEffect(() => {
        if (studentRequestId) {
            const path = window.location.pathname;
            if (path.includes('edit-studentrequest')) {
                setEditMode(true);
            }
            else if (path.includes('view-studentrequest')) {
                setViewMode(true);
            }

            fetchStudentRequest(studentRequestId);
            // Set mode to edit if courseId is present
        } else {
            setEditMode(false); // Set mode to add if no courseId is present
            setViewMode(false);
        }
    }, [studentRequestId]);

    const handleStudentSelect = (event) => {
      //  console.log(event.target.value);
        if(event.target.value){
            const selectedJson = JSON.parse(event.target.value);
            setStudentRequest(studentRequest => ({
                ...studentRequest,
                studentId: selectedJson.id,
                studentName: selectedJson.name
            }));
        }else{
            setStudentRequest(studentRequest => ({
                ...studentRequest,
                studentId: '',
                studentName: ''
            }));
        }
        
      //  console.log(event.target.value);
    };

    

    const goBack = (e) => {
        navigate('/studentrequests');
    };

    const validateForm = () => {
        const errors = {};
        if (!studentRequest.studentId) {
            errors.studentId = 'student is required';
        }
        
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setStudentRequest({ ...studentRequest, [name]: value || ''});
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
       // console.log("inside submit");
        var response = '';
        try {
            if (viewMode) {
                navigate('/studentrequests');
            }
                         
                
            else if (editMode) {
               // console.log(studentRequest);  
                var editStudentRequest={  
                    id:studentRequestId,                  
                    studentId: studentRequest.studentId,
                    request: studentRequest.request,
                    type: studentRequest.type,
                    active: studentRequest.active
                  }  
               
                // Update course if in edit mode
                response = await axiosInstance.put('/studentrequests', editStudentRequest, { showToastOnResponse: true });
            }
            else {

              //  console.log(studentRequest);  
                var addStudentRequest={                    
                        studentId: studentRequest.studentId,
                        request: studentRequest.request,
                        type: studentRequest.type,
                        active: studentRequest.active
                      }
                response = await axiosInstance.post('/studentrequests', addStudentRequest, { showToastOnResponse: true });

            }
          //  console.log(response);
            navigate('/studentrequests');

        } catch (error) {
            console.log('Error saving feedback. Please try again later.');
            console.log(error);
        }
    };

    return (
        <div>
            <div className="top">
                <h1>{editMode ? 'Edit Feedback' : viewMode ? 'View Feedback' : 'Add Feedback'}</h1>
            </div>
            <div className="bottom">
                <div className="left"></div>
                <div className="right">
                    <form onSubmit={handleSubmit}>
                        <div className="formInput">
                            <label>Select Student Enrollment Number</label>
                            <select onChange={handleStudentSelect} 
                            disabled={viewMode || editMode}
                            value={(studentRequest.studentId && JSON.stringify(findElementByIdWithReduce(students,studentRequest.studentId)))|| ""} >
                                <option value="">Select a student</option>
                                {students && students.map(option => (
                                    <option key={option.id} value={JSON.stringify(option)}>
                                        {option.enrollmentNumber}
                                    </option>
                                ))}
                            </select>
                            {errors.studentId && <div className="error-text">{errors.studentId}</div>}
                        </div>

                        <div className="formInput">
                            <label>Student Name</label>
                            <input type="text"
                                name="studentName"
                                value={studentRequest.studentName}
                                readOnly={true}
                                className={errors.studentName ? 'error' : ''} />
                            {errors.studentName && <div className="error-text">{errors.studentName}</div>}
                        </div>



                        <div className="formInput">
            <label>Request type</label>
            <select id="styled-dropdown"  
            name="type"
            value={studentRequest.type}
            onChange={handleChange}
            disabled={viewMode}
            className={errors.type ? 'error' : ''}>
                <option value="Extension">Extension</option>
                <option value="MentorChange">MentorChange</option>
                <option value="Other">Other</option>
            </select>
            {errors.type && <div className="error-text">{errors.type}</div>}
        </div>

        <div className="formInput">
              <label>Request</label>
              <input type="text"
              name="request"
              value={studentRequest.request}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.request ? 'error' : ''}/>
              {errors.request && <div className="error-text">{errors.request}</div>}
            </div>

            <div className="formInput">
            <label>Is Request Active</label>
            <select id="styled-dropdown"  
            name="active"
            value={studentRequest.active}
            onChange={handleChange}
            disabled={viewMode}
            className={errors.active ? 'error' : ''}>
                <option value="true">Yes</option>
                <option value="false">No</option>
            </select>
            {errors.active && <div className="error-text">{errors.active}</div>}
        </div>

                        <div className="buttons">
                            {!viewMode && <button type="submit">{editMode ? 'Update' : 'Save'}</button>}
                            <button onClick={goBack}>Back</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};


